import { Component, Prop, h } from '@stencil/core';

@Component({
  tag: 'bd-button',
  styleUrl: 'bd-button.css',
  shadow: true,
})
export class BdButton {
  @Prop() type: string = 'button';
  @Prop() disabled: boolean = false;
  @Prop() href?: string;

  render() {
    return (
      <a href={this.href} class={{ 'bd-button': true, 'bd-button--disabled': this.disabled }}>
        <slot />
      </a>
    );
  }
}
